import { fetchAuthSession } from "aws-amplify/auth";

export const prepareHeaders = async (headers: Headers) => {
  try {
    const auth = await fetchAuthSession();
    headers.set("Authorization", auth.tokens?.idToken?.toString() || "");
  } catch (e) {
    console.error(e);
  }
  return headers;
};
